module.exports = __webpack_public_path__ + "static/media/audio.71f49bd1.svg";